import ApplicationForm from "../components/ApplicationForm";

const LOGO = "/landclearco-logo.png";
const HERO_IMG = "/cat275xe-hero.jpg";

export default function CareersPage() {
  return (
    <div className="min-h-screen bg-white text-[#4E4E4E]">
      {/* Top bar */}
      <div className="bg-[#33373d] text-white text-sm">
        <div className="max-w-6xl mx-auto px-5 h-10 flex items-center justify-center sm:justify-start gap-6">
          <span>Raleigh, North Carolina</span>
        </div>
      </div>

      {/* Header */}
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-5 h-20 flex items-center justify-between">
          <a href="https://landclearco.com" data-testid="brand-logo">
            <img src={LOGO} alt="Land ClearCo" className="h-12 w-auto" />
          </a>
          <a
            href="#apply"
            data-testid="header-apply-btn"
            className="bg-[#00331D] text-white text-sm font-semibold uppercase tracking-wider px-6 py-3 rounded-md hover:bg-[#004d2b] transition-colors"
          >
            Apply Now
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="relative">
        <div className="absolute inset-0">
          <img src={HERO_IMG} alt="Land clearing equipment" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/55" />
        </div>
        <div className="relative max-w-4xl mx-auto px-5 py-24 md:py-32 text-center">
          <p className="text-white/90 font-semibold uppercase tracking-[0.15em] text-sm">
            Careers · Raleigh & Wake County, NC
          </p>
          <h1 className="mt-4 text-white font-bold text-4xl sm:text-5xl">
            Join the Land ClearCo Crew
          </h1>
          <p className="mt-5 text-white/90 text-lg max-w-2xl mx-auto leading-relaxed">
            We're hiring heavy equipment operators for full-time and part-time work — forestry mulching,
            excavating, and grading. Apply below and our team will be in touch.
          </p>
          <a
            href="#apply"
            data-testid="hero-apply-btn"
            className="inline-block mt-8 bg-[#00331D] text-white font-semibold uppercase tracking-wider px-8 py-4 rounded-md hover:bg-[#004d2b] transition-colors"
          >
            Start Your Application
          </a>
        </div>
      </section>

      {/* Application form */}
      <section id="apply" className="py-16 md:py-24 bg-[#F8F8F8]">
        <div className="max-w-3xl mx-auto px-5">
          <div className="text-center mb-10">
            <h2 className="text-[#1a1a1a] font-bold text-3xl sm:text-4xl">Job Application</h2>
            <p className="mt-3 text-[#585858]">
              Fields marked <span className="text-[#00331D] font-semibold">*</span> are required. Takes about 5 minutes.
            </p>
          </div>
          <ApplicationForm />
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#00331D] text-white/80">
        <div className="max-w-6xl mx-auto px-5 py-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm">
          <img src={LOGO} alt="Land ClearCo" className="h-12 w-auto bg-white/90 rounded-md p-1" />
          <p className="text-center">Land Management & Land Clearing · Raleigh, NC</p>
          <a href="/admin" className="hover:text-white transition-colors" data-testid="admin-link">Staff Login</a>
        </div>
      </footer>
    </div>
  );
}
